import React from "react";

const UserRolesContext = React.createContext([]);

export default UserRolesContext;
